export default __webpack_public_path__ + "static/poster-b8043d0acc32af6dab762c46aa0f2720.png";